import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../common/constants';
import { RootState } from '../../store';
import { IInitialSliceState } from '../../common/types/commonTypes';
import api from '../../api';
import { getCookie } from '../../common/utils';
import { configureSinglewireTokenUrl } from '../../config';

const ADD_TOKEN: string = 'addSinglewireToken';

export interface ISinglewireUserState extends IInitialSliceState {
  userId: string | null;
}
const initialState: ISinglewireUserState = {
  status: '',
  error: '',
  msg: '',
  userId: null,
};

export interface ISinglewireTokenResponse {
  message: string;
  userId?: string;
}

export interface ISinglewireTokenPyayload {
  singlewireToken: string;
  emailId?: string;
}

export const singlewireToken = createAsyncThunk(
  ADD_TOKEN,
  async (
    singlewireTokenPayload: ISinglewireTokenPyayload,
    { rejectWithValue }
  ) => {
    try {
      const { singlewireToken } = singlewireTokenPayload;
      const emailId: string = decodeURIComponent(getCookie('email'));
      const payload: ISinglewireTokenPyayload = {
        singlewireToken: `Bearer ${singlewireToken}`,
        emailId,
      };
      const response = await api.post<ISinglewireTokenResponse>(
        configureSinglewireTokenUrl,
        payload
      );

      const singlewireTokenResponse: ISinglewireTokenResponse = response.data;
      return singlewireTokenResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const singlewireTokenSlice = createSlice({
  name: ADD_TOKEN,
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(singlewireToken.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = '';
      })
      .addCase(singlewireToken.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.userId = action.payload?.userId;
        state.status = Status.SUCCESS;
      })
      .addCase(singlewireToken.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          'Unknown error occurred';
        state.status = Status.FAILED;
      });
  },
});

export const actions = {
  singlewireTokenSlice,
  ...singlewireTokenSlice.actions,
};

export const selector = (state: RootState) => state.singlewireTokenApi;

export default singlewireTokenSlice.reducer;
